module.exports = __webpack_public_path__ + "img/gift-04-c1.542cccfd.png";